import { initArchiveFitHeading } from './archive_fit_heading';

export function initRebuildCompanyArchiveFitHeading(root = document) {
  initArchiveFitHeading(root, {
    headingSelector: '.js-rebuild-company-archive-fit-h1',
    lineSelector: '.js-rebuild-company-archive-fit-line',
  });
}
